import React from "react";
import PropTypes from "prop-types";

function CustomTabPanel(props) {
  const { children, value, index } = props;

  return (
    value === index && (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
      >
        {children}{" "}
      </div>
    )
  );
}

CustomTabPanel.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default CustomTabPanel;
